import React from "react";
import Select, { SingleValue } from "react-select";
import { t } from "i18next";

interface Option {
  label: string;
  value: any;
  image: any;
}

function CustomSelectWidget(props: any) {
  const { id, value, required, disabled, readonly, onChange } = props;

  const options = [
    {
      image: "/assets/icons/category-1.svg",
      value: "category-1.svg",
      label: "category-1.svg",
    },
    {
      image: "/assets/icons/category-2.svg",
      value: "category-2.svg",
      label: "category-2.svg",
    },
    {
      image: "/assets/icons/category-3.svg",
      value: "category-3.svg",
      label: "category-3.svg",
    },
    {
      image: "/assets/icons/category-4.svg",
      value: "category-4.svg",
      label: "category-4.svg",
    },
    {
      image: "/assets/icons/category-5.svg",
      value: "category-5.svg",
      label: "category-5.svg",
    },
    {
      image: "/assets/icons/category-6.svg",
      value: "category-6.svg",
      label: "category-6.svg",
    },
    {
      image: "/assets/icons/category-7.svg",
      value: "category-7.svg",
      label: "category-7.svg",
    },
    {
      image: "/assets/icons/category-8.svg",
      value: "category-8.svg",
      label: "category-8.svg",
    },
    {
      image: "/assets/icons/category-9.svg",
      value: "category-9.svg",
      label: "category-9.svg",
    },
    {
      image: "/assets/icons/category-10.svg",
      value: "category-10.svg",
      label: "category-10.svg",
    },
    {
      image: "/assets/icons/category-11.svg",
      value: "category-11.svg",
      label: "category-11.svg",
    },
    {
      image: "/assets/icons/coupon.png",
      value: "coupon.png",
      label: "coupon.png",
    },
    {
      image: "/assets/icons/icon-1.svg",
      value: "icon-1.svg",
      label: "icon-1.svg",
    },
    {
      image: "/assets/icons/icon-2.svg",
      value: "icon-2.svg",
      label: "icon-2.svg",
    },
    {
      image: "/assets/icons/icon-3.svg",
      value: "icon-3.svg",
      label: "icon-3.svg",
    },
    {
      image: "/assets/icons/icon-4.svg",
      value: "icon-4.svg",
      label: "icon-4.svg",
    },
    {
      image: "/assets/icons/icon-5.svg",
      value: "icon-5.svg",
      label: "icon-5.svg",
    },
    {
      image: "/assets/icons/icon-6.svg",
      value: "icon-6.svg",
      label: "icon-6.svg",
    },
    {
      image: "/assets/icons/icon-bookmark.svg",
      value: "icon-bookmark.svg",
      label: "icon-bookmark.svg",
    },
    {
      image: "/assets/icons/icon-cart.svg",
      value: "icon-cart.svg",
      label: "icon-cart.svg",
    },
    {
      image: "/assets/icons/icon-clock.svg",
      value: "icon-clock.svg",
      label: "icon-clock.svg",
    },
    {
      image: "/assets/icons/icon-compare.svg",
      value: "icon-compare.svg",
      label: "icon-compare.svg",
    },
    {
      image: "/assets/icons/icon-contact.svg",
      value: "icon-contact.svg",
      label: "icon-contact.svg",
    },
    {
      image: "/assets/icons/icon-download.svg",
      value: "icon-download.svg",
      label: "icon-download.svg",
    },
    {
      image: "/assets/icons/icon-dribbble.svg",
      value: "icon-dribbble.svg",
      label: "icon-dribbble.svg",
    },
    {
      image: "/assets/icons/icon-email.svg",
      value: "icon-email.svg",
      label: "icon-email.svg",
    },
    {
      image: "/assets/icons/icon-email-2.svg",
      value: "icon-email-2.svg",
      label: "icon-email-2.svg",
    },
    {
      image: "/assets/icons/icon-facebook.svg",
      value: "icon-facebook.svg",
      label: "icon-facebook.svg",
    },
    {
      image: "/assets/icons/icon-facebook-brand.svg",
      value: "icon-facebook-brand.svg",
      label: "icon-facebook-brand.svg",
    },
    {
      image: "/assets/icons/icon-facebook-white.svg",
      value: "icon-facebook-white.svg",
      label: "icon-facebook-white.svg",
    },
    {
      image: "/assets/icons/icon-headphone.svg",
      value: "icon-headphone.svg",
      label: "icon-headphone.svg",
    },
    {
      image: "/assets/icons/icon-headphone-white.svg",
      value: "icon-headphone-white.svg",
      label: "icon-headphone-white.svg",
    },
    {
      image: "/assets/icons/icon-heart.svg",
      value: "icon-heart.svg",
      label: "icon-heart.svg",
    },
    {
      image: "/assets/icons/icon-heart-2.svg",
      value: "icon-heart-2.svg",
      label: "icon-heart-2.svg",
    },
    {
      image: "/assets/icons/icon-hot.svg",
      value: "icon-hot.svg",
      label: "icon-hot.svg",
    },
    {
      image: "/assets/icons/icon-hot-white.svg",
      value: "icon-hot-white.svg",
      label: "icon-hot-white.svg",
    },
    {
      image: "/assets/icons/icon-instagram.svg",
      value: "icon-instagram.svg",
      label: "icon-instagram.svg",
    },
    {
      image: "/assets/icons/icon-instagram-brand.svg",
      value: "icon-instagram-brand.svg",
      label: "icon-instagram-brand.svg",
    },
    {
      image: "/assets/icons/icon-instagram-white.svg",
      value: "icon-instagram-white.svg",
      label: "icon-instagram-white.svg",
    },
    {
      image: "/assets/icons/icon-invoice.svg",
      value: "icon-invoice.svg",
      label: "icon-invoice.svg",
    },
    {
      image: "/assets/icons/icon-location.svg",
      value: "icon-location.svg",
      label: "icon-location.svg",
    },
    {
      image: "/assets/icons/icon-pinterest.svg",
      value: "icon-pinterest.svg",
      label: "icon-pinterest.svg",
    },
    {
      image: "/assets/icons/icon-pinterest-brand.svg",
      value: "icon-pinterest-brand.svg",
      label: "icon-pinterest-brand.svg",
    },
    {
      image: "/assets/icons/icon-pinterest-white.svg",
      value: "icon-pinterest-white.svg",
      label: "icon-pinterest-white.svg",
    },
    {
      image: "/assets/icons/icon-plane.png",
      value: "icon-plane.png",
      label: "icon-plane.png",
    },
    {
      image: "/assets/icons/icon-print.svg",
      value: "icon-print.svg",
      label: "icon-print.svg",
    },
    {
      image: "/assets/icons/icon-search.png",
      value: "icon-search.png",
      label: "icon-search.png",
    },
    {
      image: "/assets/icons/icon-twitter.svg",
      value: "icon-twitter.svg",
      label: "icon-twitter.svg",
    },
    {
      image: "/assets/icons/icon-twitter-brand.svg",
      value: "icon-twitter-brand.svg",
      label: "icon-twitter-brand.svg",
    },
    {
      image: "/assets/icons/icon-twitter-white.svg",
      value: "icon-twitter-white.svg",
      label: "icon-twitter-white.svg",
    },
    {
      image: "/assets/icons/icon-user.svg",
      value: "icon-user.svg",
      label: "icon-user.svg",
    },
    {
      image: "/assets/icons/icon-youtube.svg",
      value: "icon-youtube.svg",
      label: "icon-youtube.svg",
    },
    {
      image: "/assets/icons/icon-youtube-brand.svg",
      value: "icon-youtube-brand.svg",
      label: "icon-youtube-brand.svg",
    },
    {
      image: "/assets/icons/icon-youtube-white.svg",
      value: "icon-youtube-white.svg",
      label: "icon-youtube-white.svg",
    },
    {
      image: "/assets/icons/logo-apple.svg",
      value: "logo-apple.svg",
      label: "logo-apple.svg",
    },
    {
      image: "/assets/icons/logo-facebook.svg",
      value: "logo-facebook.svg",
      label: "logo-facebook.svg",
    },
    {
      image: "/assets/icons/logo-google.svg",
      value: "logo-google.svg",
      label: "logo-google.svg",
    },
    {
      image: "/assets/icons/payment-master.svg",
      value: "payment-master.svg",
      label: "payment-master.svg",
    },
    {
      image: "/assets/icons/payment-paypal.svg",
      value: "payment-paypal.svg",
      label: "payment-paypal.svg",
    },
    {
      image: "/assets/icons/payment-visa.svg",
      value: "payment-visa.svg",
      label: "payment-visa.svg",
    },
    {
      image: "/assets/icons/payment-zapper.svg",
      value: "payment-zapper.svg",
      label: "payment-zapper.svg",
    },
    {
      image: "/assets/icons/phone-call.svg",
      value: "phone-call.svg",
      label: "phone-call.svg",
    },
    {
      image: "/assets/icons/search.png",
      value: "search.png",
      label: "search.png",
    },
    {
      image: "/assets/icons/social-fb.svg",
      value: "social-fb.svg",
      label: "social-fb.svg",
    },
    {
      image: "/assets/icons/social-insta.svg",
      value: "social-insta.svg",
      label: "social-insta.svg",
    },
    {
      image: "/assets/icons/social-pin.svg",
      value: "social-pin.svg",
      label: "social-pin.svg",
    },
    {
      image: "/assets/icons/social-tw.svg",
      value: "social-tw.svg",
      label: "social-tw.svg",
    },
  ];

  const handleOnChange = (newValue: SingleValue<Option>) => {
    const selectedOption = newValue as Option | null;
    const model = selectedOption?.value ?? null;
    onChange(model);
  };

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      padding: "5px",
      fontSize: "16px",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#333",
      display: "flex",
      alignItems: "center",
    }),
  };

  return (
    <Select
      id={id}
      options={options}
      value={options.find((opt) => opt.value === value)}
      required={required}
      placeholder={t("select_icon")}
      isDisabled={disabled || readonly}
      onChange={handleOnChange}
      styles={customStyles}
      isClearable={true}
      formatOptionLabel={(option) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img
            src={option.image}
            alt={option.label}
            style={{ width: "24px", height: "24px" }}
          />
          {option.label}
        </div>
      )}
    />
  );
}
function IconSelector(props: any) {
  const { id, options, value, required, disabled, readonly, onChange } = props;
  return (
    <CustomSelectWidget
      id={id}
      options={options.enumOptions}
      filters={options.filters}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
    />
  );
}

export default IconSelector;
